export default __webpack_public_path__ + "static/media/logo_outlined.bee600a8.svg";